import React from 'react';
import PropTypes from 'prop-types';
import {
  formatOptionalCollateralAmount,
  formatOptionalUsd,
} from '../../utils/cryptoUtils';

const GoalAmountSummary = ({
  variant,
  amount,
  coinType,
  contractualLtvDisplay,
  description,
  summaryLabel,
}) => {
  const defaultLabel = variant === 'deposit' ? 'TRANSFER AMOUNT' : 'SUGGESTED EXTRA PAYMENT';
  const label = summaryLabel || defaultLabel;
  const display = variant === 'deposit'
    ? formatOptionalCollateralAmount(amount, coinType)
    : formatOptionalUsd(amount);
  const targetLtv = contractualLtvDisplay === '-' ? '-' : contractualLtvDisplay;

  const subtext = (() => {
    if (variant === 'payment') {
      return description || `Returns to target ${targetLtv} LTV`;
    }

    return description || `Returns to your contract LTV of ${targetLtv}.`;
  })();

  return (
    <div className="lower-ltv-modal__goal-amount-summary">
      <div className="lower-ltv-modal__deposit-box text-center">
        <small className="lower-ltv-modal__deposit-label">{label}</small>
        <div className="lower-ltv-modal__deposit-amount">{display}</div>
        <p className="lower-ltv-modal__deposit-subtext mb-0">
          {subtext}
        </p>
      </div>
    </div>
  );
};

GoalAmountSummary.propTypes = {
  variant: PropTypes.oneOf(['deposit', 'payment']).isRequired,
  amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  coinType: PropTypes.string,
  contractualLtvDisplay: PropTypes.string,
  description: PropTypes.string,
  summaryLabel: PropTypes.string,
};

GoalAmountSummary.defaultProps = {
  amount: null,
  coinType: '',
  contractualLtvDisplay: '-',
  description: '',
  summaryLabel: '',
};

export default GoalAmountSummary;
